<template>
  <Transition name="fade">
    <div v-if="value" class="app-modal-wrapper">
      <div class="app-modal">
        <div>
          <button class="app-modal-close" type="button" @click="handleClose" />
        </div>
        <div class="app-modal-body">
          <header>
            <h3 class="app-modal-title">Reactivate your membership</h3>
          </header>
          <p>
            If your membership is lapsed, please update your payment details to begin to reactive your membership. If
            your membership is paused, please email us at
            <a href="mailto:members@thecultivist.com">members@thecultivist.com</a> and we can help with next steps.
          </p>
        </div>
        <div class="app-modal-actions">
          <div @click="handleClose">
            <RouterLink class="action active" :to="{ name: 'payment-details' }">Update payment details</RouterLink>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'RenewYourMembershipModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-modal {
  &-wrapper {
    position: fixed;
    width: 100%;
    top: 0;
    height: 100vh;
    left: 0;
    z-index: 999999999;
    background-color: rgba(vars.$c-total-black, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 600px;
  margin: 16px;
  padding: 18px 16px 32px;
  text-align: left;
  background-color: vars.$c-total-white;
  overflow-x: hidden;

  &-body,
  &-actions {
    padding: 0 8px;

    @media (min-width: vars.$mobile-break-point + 1px) {
      padding: 0 24px;
    }
  }

  &-body {
    p,
    a {
      color: vars.$c-dark-5b;
    }
  }

  &-close {
    display: block;
    width: 1em;
    height: 1em;
    margin-left: auto;
    color: vars.$c-total-black;
    opacity: 0.4;
    background: transparent
      url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e")
      center/1em auto no-repeat;

    &:hover {
      opacity: 0.75;
    }
  }

  &-title {
    margin-top: 12px;
    margin-bottom: 24px;
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 6px;
    text-transform: uppercase;
  }

  &-actions {
    display: flex;
    flex-direction: column;
    margin-top: 16px;

    @media (min-width: vars.$tablet-break-point) {
      flex-direction: row;
      justify-content: space-around;
      padding: 0;
    }

    .action {
      display: block;
      min-width: 180px;
      margin-top: 16px;
      padding: 8px 16px;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: vars.$c-dark-gray;
      border: 1px solid vars.$c-dark-gray;
      border-radius: 1px;
      background-color: vars.$c-total-white;

      &.active {
        color: vars.$c-total-white;
        background-color: vars.$c-dark-gray;

        &:hover,
        &:focus {
          color: vars.$c-total-white !important;
          background-color: lighten(vars.$c-dark-gray, 20%);
        }
      }
    }
  }
}
</style>
